import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { JuniferComm } from "./juniferComm"
import { IJuniferComm } from "./juniferComm.types"
import { AccountCommunication } from "@/api/backofficeRest/generated/model"

export interface IJuniferFile {
  id: number
  filename: string
}

export type JunCommStatusText =
  | "Pending"
  | "Successful"
  | "SuccessfulWithWarnings"
  | "NoDeliveries"
  | "Failed"

export const JuniferCommParser: IParser<IJuniferComm, AccountCommunication> = {
  toDomain: (data: AccountCommunication) => {
    try {
      return new JuniferComm(
        data.id,
        data.type,
        dayjs(data.createdDttm),
        data.status as JunCommStatusText,
        data.files ?? [],
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
